<header>
  <div class="integrations-wrapper">

    <div id="yaloAppsButton" class="btn-header-action" (click)="presentYaloApps($event)">
      <img src="assets/icons/yalo-line-primary.svg" alt="yalo-logo-primary">
    </div>

    <!-- <div id='yaloHelpButton' class="btn-header-action">
      <i class="ri-questionnaire-line"></i>
    </div> -->
  </div>
  <img class="header-logo" src="assets/logo/yalocobro-logo.svg" alt="yalocobro-logo">
  <div class="user-menu">
    <div class="btn-header-action" (click)="presentNotifications($event)">
      <img src="assets/icons/yalo-notification-primary.svg" alt="yalo-notification-primary">
    </div>
    <app-user-menu *ngIf="ui.canShowSidebar$ | async"></app-user-menu>
  </div>
</header>
